<template>
    <div>
        <div style="width: 100%;">
            <el-row>
                <el-col :span="7">
                    <el-select v-model="ntId" style="width: 150px;margin-right: 3px;" placeholder="请选择设备大类" @change="currentPage=1;updateTable()">
                        <el-option v-for="item in mainCategory" :key="item.ntId" :label="item.name" :value="item.ntId"></el-option>
                    </el-select>
                    <el-button type="primary" @click="addTypeDialog">新增</el-button>
                </el-col>
            </el-row>
        </div>
        <div style="margin-top: 25px;width: 100%;">
            <el-row :gutter="3">
                <el-col :span="7" v-for="item in deviceType">
                    <el-card shadow="hover" style="text-align: center;margin-top: 10px;">
                        <div>
                            <div style="width: 95%;text-align: right;line-height: 20px;">
                                <i @click="updateTypeDialog(item.mid)" class="el-icon-edit iconClass"></i>
                                <i @click="delType(item)" class="el-icon-close iconClass"></i>
                            </div>
                        </div>
                        <div style="margin-top: 15px;">
                            <el-row :gutter="5">
                                <el-col :span="6">
                                    <!-- <img :src="item.image" style="width: 80px;height: 80px;" /> -->
                                    <img
                                         @load="setSize($event,80,80)"
                                         :src="item.image"
                                         :style="{width: imgWidth + 'px', height: imgHeight + 'px'}" />
                                </el-col>
                                <el-col :span="18">
                                    <div>{{ntIdDesc(item.ntId)}}</div>
                                    <div>{{item.name}}</div>
                                    <div>{{item.model}}</div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <el-pagination
                           background
                           style="text-align:center;margin-top: 24px;margin-bottom:55px;"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="[9]"
                           :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total"></el-pagination>
        </div>
        <el-dialog :title="title" :visible.sync="myDialog" :close-on-click-modal="false">
            <el-form label-position="right" label-width="100px" :model="equipmentModel" ref="equipmentModel" :rules="rules">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="名称" prop="name">
                            <el-input v-model="equipmentModel.name" type="text" style="width: 180px;" placeholder="请输入名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="型号" prop="model">
                            <el-input v-model="equipmentModel.model" :disabled="updateType" type="text" style="width: 180px;" placeholder="请输入型号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="图片" prop="imageStr">
                    <el-upload
                               class="avatar-uploader"
                               :action="updateAction"
                               :show-file-list="false"
                               :on-success="handleAvatarSuccess"
                               :before-upload="beforeAvatarUpload">
                        <img v-if="equipmentModel.imageStr" :src="equipmentModel.imageStr" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <div v-if="equipmentModel.ntId==1024 || equipmentModel.ntId==1030|| equipmentModel.ntId==1106 ||equipmentModel.ntId==1131">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="净水量检测" prop="hasLiquidDetection">
                                <el-checkbox v-model="equipmentModel.hasLiquidDetection">装配传感器</el-checkbox>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="净水流速" prop="waterYield" v-if="!equipmentModel.hasLiquidDetection">
                                <el-input v-model.number="equipmentModel.waterYield" type="text" style="width: 200px;" placeholder="毫升/分钟,用于计算净水量"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="TDS名称" prop="tdsNames">
                                <el-input v-model="equipmentModel.tdsNames" type="text" style="width: 200px;" placeholder="多个tds使用逗号分隔" @input="convertComma('tdsNames')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="滤芯名称" prop="filterNames">
                                <el-input v-model="equipmentModel.filterNames" type="text" style="width: 200px;" placeholder="多个滤芯使用逗号分隔" @input="convertComma('filterNames')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="净水比" prop="wasteWaterThan">
                                <el-input
                                          v-model.number="equipmentModel.wasteWaterThan"
                                          type="number"
                                          step="0.1"
                                          max="1"
                                          min="0.1"
                                          style="width: 200px;"
                                          placeholder="净水/(净水+废水)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="滤芯重置限制" prop="filterLimit">
                                <el-select v-model="equipmentModel.filterLimit" placeholder="请选择">
                                    <el-option label="无" :value="0"></el-option>
                                    <el-option label="限内部滤芯" :value="1"></el-option>
                                </el-select>
                                <el-tooltip class="item" effect="light" content="控制终端用户在重置滤芯时是否需要输入滤芯编码" placement="right-start">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :loading="loadingForAdd" v-if="addType" @click="newDeviceType">新建</el-button>
                <el-button :loading="loadingForUpdate" v-if="updateType" @click="updateDeviceType">修改</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'deviceType',
        components: {},
        data() {
            return {
                imgWidth: 0,
                imgHeight: 0,
                ntId: '',
                deviceType: [],
                modelList: [],
                mainCategory: [],
                myDialog: false,
                total: 0,
                currentPage: 1,
                pageSize: 9,
                addType: false,
                updateType: false,
                loadingForAdd: false,
                loadingForUpdate: false,
                title: '',
                mid: '',
                updateAction: this.$store.getters.getApiValue + "/product/uploadImage.do",
                rules: {
                    name: [{
                        trigger: 'change',
                        required: true,
                        message: '名称不能为空!'
                    }],
                    model: [{
                        trigger: 'change',
                        required: true,
                        message: '型号不能为空!'
                    }],
                    imageStr: [{
                        trigger: 'change',
                        required: true,
                        message: '请添加图片!'
                    }],
                    waterYield: [{
                        type: "integer",
                        trigger: 'change',
                        required: true,
                        message: '请输入正确净水流速!'
                    }],
                    wasteWaterThan: [{
                        type: "float",
                        trigger: 'blur',
                        required: true,
                        message: '请输入正确废水比!'
                    }],
                    tdsNames: [{
                        trigger: 'blur',
                        required: true,
                        message: '请输入正确TDS名称!'
                    }],
                    filterNames: [{
                        trigger: 'blur',
                        required: true,
                        message: '请输入正确滤芯名称!'
                    }]
                },
                equipmentModel: {
                    //通用属性
                    mid: "",
                    ntId: "",
                    name: "",
                    model: "",
                    imageStr: "",
                    //净水器属性
                    hasLiquidDetection: false,
                    waterYield: "",
                    wasteWaterThan: "",
                    tdsNames: "",
                    filterNames: "",
                    filterLimit:0
                }
            }
        },
        watch: {},
        mounted() {
            this.listMainCategory();
            this.updateTable();
        },
        beforeDestroy() {},
        methods: {
            ntIdDesc(ntId){
                let desc="";
                this.mainCategory.forEach(element => {
                    if(element.ntId==ntId){
                        desc=element.name
                        return false
                    }
                });
                return desc
            },
            convertComma(name) {
                this.equipmentModel[name] = this.equipmentModel[name].replace(/，/g, ',');
            },
            listMainCategory() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/equipmentModel/listCategory.do')
                    .then(function(response) {
                        var data = response.data;
                        if (data.status == "200") {
                            thiz.mainCategory = data.data;
                        } else {
                            thiz.$message.error(data.message);
                        }
                    }).catch(function(error) {
                        console.log(error);
                        thiz.$message.error("系统异常!请与管理员联系!");
                    });
            },
            updateTable() {
                var thiz = this;
                const loading = this.$loading({
                    lock: true,
                    text: '获取表格数据中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(() => {
                    loading.close();
                }, 3000);
                axios.get(this.$store.getters.getApiValue + '/equipmentModel/list.do', {
                    params: {
                        ntId:thiz.ntId,
                        pageId: thiz.currentPage,
                        size: thiz.pageSize
                    }
                }).then(function(response) {
                    loading.close();
                    var data = response.data;
                    if (data.status == "200") {
                        var list = data.data;
                        for (var i = 0; i < list.length; i++) {
                            var url = list[i].image;
                            var f = url.substring(0, url.lastIndexOf("."));
                            var s = url.substring(url.lastIndexOf("."));
                            url = f + "_160x160" + s;
                            list[i].image = url;
                        }
                        thiz.deviceType = list;
                        thiz.total = data.totalCount;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    loading.close();
                    console.log(error);
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.updateTable();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.updateTable();
            },
            addTypeDialog() {
                if (this.ntId == "") {
                    this.$message.error("请选择设备大类");
                    return;
                }
                this.equipmentModel.ntId = this.ntId;
                this.myDialog = true;
                this.title = "新增类型";
                this.addType = true;
                this.updateType = false;
                this.$nextTick(() => {
                    this.$refs.equipmentModel.resetFields()
                })
            },
            updateTypeDialog(mid) {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/equipmentModel/get.do', {
                    params: {
                        mid: mid
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.equipmentModel.ntId = data.data.ntId;
                        thiz.myDialog = true;
                        thiz.$nextTick(() => {
                            thiz.title = "修改类型";
                            thiz.updateType = true;
                            thiz.addType = false;
                            thiz.equipmentModel.mid = data.data.mid;
                            thiz.equipmentModel.name = data.data.name;
                            thiz.equipmentModel.model = data.data.model;
                            thiz.equipmentModel.imageStr = data.data.image;
                            if (data.data.ntId == 1024 || data.data.ntId == 1030 || data.data.ntId == 1106 ||data.data.ntId == 1131) {
                                thiz.equipmentModel.waterYield = data.data.waterYield;
                                thiz.equipmentModel.hasLiquidDetection = data.data.hasLiquidDetection;
                                thiz.equipmentModel.wasteWaterThan = data.data.wasteWaterThan;
                                thiz.equipmentModel.filterNames = data.data.filterNames;
                                thiz.equipmentModel.tdsNames = data.data.tdsNames;
                                thiz.equipmentModel.filterLimit = data.data.filterLimit;
                            }
                        })
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    console.log(error);
                    thiz.$message.error("系统异常!请与管理员联系!");
                });
            },
            delType(item) {
                var thiz = this;
                this.$confirm('确认删除名为“' + item.name + '”的设备类型吗?')
                    .then(_ => {
                        axios.get(thiz.$store.getters.getApiValue + '/equipmentModel/delete.do', {
                            params: {
                                mid: item.mid
                            }
                        }).then(function(response) {
                            var data = response.data;
                            if (data.status == "200") {
                                thiz.$message.success('删除成功!');
                                thiz.updateTable();
                            } else {
                                thiz.$message.error(data.message);
                            }
                        }).catch(function(error) {
                            console.log(error);
                            thiz.$message.error("系统异常!请与管理员联系!");
                        });
                    }).catch(_ => {});
            },
            newDeviceType() {
                var thiz = this;
                this.$refs["equipmentModel"].validate((valid) => {
                    if (valid) {
                        var params = {
                            ntId: thiz.equipmentModel.ntId,
                            model: thiz.equipmentModel.model,
                            name: thiz.equipmentModel.name,
                            image: thiz.equipmentModel.imageStr,
                        };
                        var url = "/equipmentModel/add.do";
                        thiz.loadingForAdd = true;
                        if (thiz.equipmentModel.ntId == 1024 || thiz.equipmentModel.ntId == 1030 || thiz.equipmentModel.ntId == 1106 || thiz.equipmentModel.ntId == 1131) {
                            params.hasLiquidDetection = thiz.equipmentModel.hasLiquidDetection;
                            if (params.hasLiquidDetection) {
                                params.waterYield = 0;
                            } else {
                                params.waterYield = thiz.equipmentModel.waterYield;
                            }
                            params.wasteWaterThan = thiz.equipmentModel.wasteWaterThan;
                            params.tdsNames = thiz.equipmentModel.tdsNames;
                            params.filterNames = thiz.equipmentModel.filterNames;
                            url = '/equipmentModel/addWaterPurifier.do';
                        }
                        axios.get(this.$store.getters.getApiValue + url, {
                            params: params
                        }).then(function(response) {
                            var data = response.data;
                            if (data.status == "200") {
                                thiz.$message.success('新增成功!');
                                thiz.updateTable();
                                thiz.myDialog = false;
                            } else {
                                thiz.$message.error(data.message);
                            }
                        }).catch(function(error) {
                            console.log(error);
                            thiz.$message.error("系统异常!请与管理员联系!");
                        }).finally(() => {
                            thiz.loadingForAdd = false;
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            updateDeviceType() {
                var thiz = this;
                this.$refs["equipmentModel"].validate(async valid => {
                    if (valid) {
                        this.loadingForUpdate = true;
                        var params = {
                            mid: thiz.equipmentModel.mid,
                            ntId: thiz.equipmentModel.ntId,
                            model: thiz.equipmentModel.model,
                            name: thiz.equipmentModel.name,
                            image: thiz.equipmentModel.imageStr,
                        };
                        var url = "/equipmentModel/update.do";
                        if (thiz.equipmentModel.ntId == 1024 || thiz.equipmentModel.ntId == 1030 || thiz.equipmentModel.ntId == 1106 || thiz.equipmentModel.ntId == 1131) {
                            params.hasLiquidDetection = thiz.equipmentModel.hasLiquidDetection;
                            if (params.hasLiquidDetection) {
                                params.waterYield = 0;
                            } else {
                                params.waterYield = thiz.equipmentModel.waterYield;
                            }
                            params.wasteWaterThan = thiz.equipmentModel.wasteWaterThan;
                            params.tdsNames = thiz.equipmentModel.tdsNames;
                            params.filterNames = thiz.equipmentModel.filterNames;
                            url = '/equipmentModel/updateWaterPurifier.do';
                        }
                        axios.get(this.$store.getters.getApiValue + url, {
                            params: params
                        }).then(function(response) {
                            var data = response.data;
                            if (data.status == "200") {
                                thiz.$message.success('更新成功!');
                                thiz.updateTable();
                                thiz.myDialog = false;
                            } else {
                                thiz.$message.error(data.message);
                            }
                        }).catch(function(error) {
                            console.log(error);
                            thiz.$message.error("系统异常!请与管理员联系!");
                        }).finally(() => {
                            this.loadingForUpdate = false;
                        });
                    } else {
                        this.$message.error("填写不完整或格式不正确，请确认！")
                    }
                })
            },
            handleAvatarSuccess(res, file) {
                this.equipmentModel.imageStr = res.data;
                console.log(this.equipmentModel.imageStr)
            },
            beforeAvatarUpload(file) {},
            setSize(e, maxWidth, maxHeight) {
                const width = e.target.naturalWidth
                const height = e.target.naturalHeight
                let wratio = width * 1.0 / maxWidth;
                let hratio = height * 1.0 / maxHeight;
                let ratio = width * 1.0 / height;
                if (wratio >= hratio) {
                    this.imgWidth = maxWidth;
                    this.imgHeight = this.imgWidth * 1.0 / ratio
                } else {
                    this.imgHeight = maxHeight;
                    this.imgWidth = this.imgHeight * ratio;
                }
            },
        }
    }
</script>

<style>
    .iconClass {
        font-size: 16px;
        margin-right: 12px;
        vertical-align: middle;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
    }

    .avatar {
        width: 50px;
        height: 50px;
        display: block;
    }
</style>